// eslint-disable-next-line import/prefer-default-export
export const parseNumber = (value: number | string): number => {
  // @ts-ignore
  const parsed = parseInt(value, 10);
  return !Number.isNaN(parsed) ? parsed : 0;
};
